import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';


export const getLanguageSettingsFunc = createAsyncThunk(
    "languageSettings/get",
    async (query = '', thunkAPI) => {
        try {
            const res = await api.get(`language-settings${query}`);
            return res.data.data;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    }
)
const getLanguageSettingsSlicer = createSlice({
    name : "languageSettings/get",
    initialState : {
         loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    extraReducers : builder => {
        builder.addCase(getLanguageSettingsFunc.pending, (state) => {
                   state.loading = true;
                   state.error = null;
                   state.apiErrors = {};
               })
                   .addCase(getLanguageSettingsFunc.fulfilled, (state, action) => {
                       state.loading = false;
                       state.data = action.payload;
                       state.successMessage = action.payload?.message || "";
       
                   })
                   .addCase(getLanguageSettingsFunc.rejected, (state, action) => {
                       state.loading = false;
                       state.error = true;
                       state.apiErrors = action.payload?.errors || {};
                   });
    }
})
export default getLanguageSettingsSlicer.reducer;